import { render, staticRenderFns } from "./concrete-detail.vue?vue&type=template&id=e72aefdc&"
import script from "./concrete-detail.vue?vue&type=script&lang=js&"
export * from "./concrete-detail.vue?vue&type=script&lang=js&"
import style0 from "./concrete-detail.vue?vue&type=style&index=0&id=e72aefdc&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports